import { useState } from 'react';
import { AutoComplete, Spin } from 'antd';
import { useGetParentSearchResultsQuery, useQuickSearchParentMutation } from '@/services/parent-api';

const ParentQuickSearch = ({ onParentSelect }) => {
  const [searchParents, { isLoading: loadingSearch }] = useQuickSearchParentMutation();

  const [searchId, setSearchId] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const { data, isFetching } = useGetParentSearchResultsQuery(
    { searchId, pageNumber, pageSize: 5 },
    { skip: !searchId },
  );

  const handleSelect = (value, option) => {
    onParentSelect(option.key, value);
  };

  function debounce(fn, delay) {
    let timeoutId;
    return function (...args) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        fn(...args);
      }, delay);
    };
  }

  const makeFullName = (parent) => {
    const primary =
      parent.primary.name.first +
      (parent.primary.name.middle ? ' ' + parent.primary.name.middle : '') +
      ' ' +
      parent.primary.name.last +
      (parent.primary.name.suffix ? ' ' + parent.primary.name.suffix : '');
    let significantOther = '';
    if (parent.hasSignificantOther) {
      significantOther =
        parent.significantOther.name.first +
        (parent.significantOther.name.middle ? ' ' + parent.significantOther.name.middle : '') +
        ' ' +
        parent.significantOther.name.last +
        (parent.significantOther.name.suffix ? ' ' + parent.significantOther.name.suffix : '');
    }
    return primary + (parent.hasSignificantOther ? ' / ' + significantOther : '');
  };

  const onSearch = debounce(async (value) => {
    if (loadingSearch || !value) return;
    try {
      const res = await searchParents({ searchText: value }).unwrap();
      setSearchId(res);
      setPageNumber(1);
    } catch (err) {
      console.error('Search error:', err);
    }
  }, 500); // 500ms delay

  return (
    <>
      <AutoComplete
        placeholder="Parent Name"
        onSearch={onSearch}
        onSelect={handleSelect}
        options={data?.data?.map((parent) => ({ value: makeFullName(parent), key: parent.parentId })) || []}
        notFoundContent={isFetching ? <Spin size="small" /> : null}
      />
    </>
  );
};

export default ParentQuickSearch;
